import { render, staticRenderFns } from "./IchingGateContent.vue?vue&type=template&id=0df1543e&"
import script from "./IchingGateContent.vue?vue&type=script&lang=js&"
export * from "./IchingGateContent.vue?vue&type=script&lang=js&"
import style0 from "./IchingGateContent.vue?vue&type=style&index=0&id=0df1543e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports